import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from './assets/menu.svg'
import _imports_1 from './assets/search.svg'
import _imports_2 from './assets/plus.svg'
import _imports_3 from './assets/issues.svg'
import _imports_4 from './assets/pull.svg'
import _imports_5 from './assets/inbox.svg'


const _hoisted_1 = { class: "top" }
const _hoisted_2 = { class: "right" }
const _hoisted_3 = { class: "grid" }
const _hoisted_4 = { class: "column1" }
const _hoisted_5 = { class: "div" }
const _hoisted_6 = {
  id: "profileDiv",
  class: "profileDiv"
}
const _hoisted_7 = { class: "div0" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "div1" }
const _hoisted_10 = ["href"]
const _hoisted_11 = { key: 1 }

import { ref } from "vue";
import fetch from "node-fetch";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const username = ref<string>("");
const profile = ref<null | Record<string, any>>(null);
const error = ref<string | null>(null);

const fetchGitHubProfile = async () => {
  profile.value = null;
  error.value = null;

  try {
    const response = await fetch(`https://api.github.com/users/${username.value}`);
    if (!response.ok) throw new Error("Profile not found");

    profile.value = await response.json();
  } catch (err) {
    error.value = (err as Error).message;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_h = _resolveComponent("h")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "left" }, [
        _createElementVNode("button", { class: "btn" }, [
          _createElementVNode("img", { src: _imports_0 })
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("input", {
          id: "lookup",
          class: "lookup",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((username).value = $event)),
          type: "text",
          placeholder: "Type / to search"
        }, null, 512), [
          [_vModelText, username.value]
        ]),
        _createElementVNode("button", {
          id: "submitbtn",
          class: "btn",
          onClick: fetchGitHubProfile
        }, _cache[1] || (_cache[1] = [
          _createElementVNode("img", { src: _imports_1 }, null, -1)
        ])),
        _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"li\" data-v-9a168832></div><button class=\"btn\" data-v-9a168832><img src=\"" + _imports_2 + "\" data-v-9a168832></button><button class=\"btn\" data-v-9a168832><img src=\"" + _imports_3 + "\" data-v-9a168832></button><button class=\"btn\" data-v-9a168832><img src=\"" + _imports_4 + "\" data-v-9a168832></button><button class=\"btn\" data-v-9a168832><img src=\"" + _imports_5 + "\" data-v-9a168832></button>", 5))
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[7] || (_cache[7] = _createStaticVNode("<div class=\"column0\" data-v-9a168832><div class=\"div\" data-v-9a168832><h2 data-v-9a168832>Top repositories</h2><input class=\"lookup\" type=\"text\" placeholder=\"Find a repository...\" disabled data-v-9a168832><ul data-v-9a168832><li data-v-9a168832><span class=\"circ\" data-v-9a168832></span>flglflgl/github</li><li data-v-9a168832><span class=\"circ\" data-v-9a168832></span>flglflgl/shorturl</li><li data-v-9a168832><span class=\"circ\" data-v-9a168832></span>flglflgl/tip</li></ul><button class=\"showbtn\" data-v-9a168832>Show more</button></div></div>", 1)),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _cache[6] || (_cache[6] = _createElementVNode("h1", null, "Home", -1)),
          _createElementVNode("div", _hoisted_6, [
            (profile.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("img", {
                      src: profile.value.avatar_url,
                      alt: "Profile Image"
                    }, null, 8, _hoisted_8),
                    _createVNode(_component_h, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(profile.value.name || "No name provided"), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("p", null, "User: " + _toDisplayString(profile.value.login), 1),
                    _createElementVNode("p", null, "Followers: " + _toDisplayString(profile.value.followers), 1),
                    _createElementVNode("p", null, "Public Repositories: " + _toDisplayString(profile.value.public_repos), 1),
                    _createElementVNode("a", {
                      href: profile.value.html_url,
                      target: "_blank"
                    }, _cache[4] || (_cache[4] = [
                      _createElementVNode("button", { class: "linkbtn" }, "Visit Profile", -1)
                    ]), 8, _hoisted_10)
                  ])
                ], 64))
              : (error.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(error.value), 1))
                : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}
}

})